import { render } from "./CoprarConvert.vue?vue&type=template&id=646264ed&scoped=true"
import script from "./CoprarConvert.vue?vue&type=script&lang=js"
export * from "./CoprarConvert.vue?vue&type=script&lang=js"

import "./CoprarConvert.vue?vue&type=style&index=0&id=646264ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646264ed"]])

export default __exports__